import { Button } from "@synthesis/shared-ui";
import { IconClose } from "@synthesis/shared-icons";
import type { ReactNode } from "react";

type CrossingObjectBlockHeaderProps = {
  title: string;
  action?: ReactNode;
  onRemove?: () => void;
};

export const CrossingObjectBlockHeader = ({ title, action, onRemove }: CrossingObjectBlockHeaderProps) => (
  <div className="flex flex-wrap items-center justify-between gap-2">
    <h3 className="subtitle-lg text-type-minor">{title}</h3>
    {(action || onRemove) && (
      <div className="flex flex-wrap items-center gap-2">
        {action}
        {onRemove && (
          <Button type="button" theme="text" size="sm" className="h-6 px-2 py-0.5" leftIcon={<IconClose className="size-5" />} onClick={onRemove}>
            Удалить
          </Button>
        )}
      </div>
    )}
  </div>
);

type CrossingObjectOptionalLabelProps = {
  label: string;
  optionalHint?: string;
  required?: boolean;
};

export const CrossingObjectOptionalLabel = ({ label, optionalHint, required }: CrossingObjectOptionalLabelProps) => (
  <span className="paragraph-sm text-type-common">
    {label}
    {optionalHint && <span className="text-type-light"> {optionalHint}</span>}
    {required && <span className="text-system-error-50"> *</span>}
  </span>
);

type CrossingObjectFormFieldProps = {
  label: ReactNode;
  children: ReactNode;
  className?: string;
};

export const CrossingObjectFormField = ({ label, children, className }: CrossingObjectFormFieldProps) => (
  <div className={className}>
    <div className="mb-2">{label}</div>
    {children}
  </div>
);
